<div class="w-full h-full flex flex-col justify-center items-center gap-2 sm:gap-2.5 md:gap-3 lg:gap-3.5 xl:gap-4">
  @if (metrics) {
  <!-- Production Metric Card -->
  <div
    class="w-full h-full bg-white rounded-lg sm:rounded-lg md:rounded-xl lg:rounded-xl xl:rounded-2xl p-3 sm:p-3 md:p-4 lg:p-4 xl:p-5 flex-1 flex flex-col justify-between">
    <div class="flex flex-col gap-0.5 sm:gap-1">
      <span
        class="text-dashboard-bg font-bold text-[9px] sm:text-[10px] md:text-xs lg:text-sm xl:text-base uppercase tracking-wider opacity-80">
        Monthly Production
      </span>
      <span class="text-dashboard-bg font-black text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl leading-none">
        {{ metrics.productionThisMonth | number:'1.0-0' }}
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        Pounds produced
      </span>
    </div>
    <div class="flex items-center gap-1 mt-auto">
      <span
        [class]="'text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-bold ' + (getChangeColor(getProductionChange()) === 'positive' ? 'text-green-500' : 'text-red-500')">
        {{ getChangeColor(getProductionChange()) === 'positive' ? '+' : '' }}{{ getProductionChange() | number:'1.1-1'
        }}%
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        vs March
      </span>
    </div>
  </div>

  <!-- Machine Efficiency Card -->
  <div
    class="w-full h-full bg-white rounded-lg sm:rounded-lg md:rounded-xl lg:rounded-xl xl:rounded-2xl p-3 sm:p-3 md:p-4 lg:p-4 xl:p-5 flex-1 flex flex-col justify-between">
    <div class="flex flex-col gap-0.5 sm:gap-1">
      <span
        class="text-dashboard-bg font-bold text-[9px] sm:text-[10px] md:text-xs lg:text-sm xl:text-base uppercase tracking-wider opacity-80">
        Machine Efficiency
      </span>
      <span class="text-dashboard-bg font-black text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl leading-none">
        {{ metrics.machineEfficiency }}%
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        Active / Total machines
      </span>
    </div>
    <div class="flex items-center gap-1 mt-auto">
      <span
        [class]="'text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-bold ' + (getChangeColor(getMachineEfficiencyChange()) === 'positive' ? 'text-green-500' : 'text-red-500')">
        {{ getMachineEfficiencyChange() >= 0 ? '+' : '' }}{{ getMachineEfficiencyChange() | number:'1.1-1' }}%
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        vs March
      </span>
    </div>
  </div>

  <!-- Quality Rejection Card -->
  <div
    class="w-full h-full bg-white rounded-lg sm:rounded-lg md:rounded-xl lg:rounded-xl xl:rounded-2xl p-3 sm:p-3 md:p-4 lg:p-4 xl:p-5 flex-1 flex flex-col justify-between">
    <div class="flex flex-col gap-0.5 sm:gap-1">
      <span
        class="text-dashboard-bg font-bold text-[9px] sm:text-[10px] md:text-xs lg:text-sm xl:text-base uppercase tracking-wider opacity-80">
        Quality Rejection
      </span>
      <span class="text-dashboard-bg font-black text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl leading-none">
        {{ metrics.qualityRejectionRate }}%
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        Rejected pounds
      </span>
    </div>
    <div class="flex items-center gap-1 mt-auto">
      <span
        [class]="'text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-bold ' + (getQualityRejectionChange() >= 0 ? 'text-green-500' : 'text-red-500')">
        {{ getQualityRejectionChange() >= 0 ? '+' : '' }}{{ getQualityRejectionChange() | number:'1.1-1' }}%
      </span>
      <span class="text-dashboard-bg/60 font-medium text-[7px] sm:text-[8px] md:text-[9px] lg:text-xs xl:text-sm">
        vs March
      </span>
    </div>
  </div>
  } @else {
  <div class="w-full h-full flex items-center justify-center">
    <span class="text-white/40 text-xs sm:text-sm">No metrics data</span>
  </div>
  }
</div>